/* TEST */
export const GET_TEST_DATA = "GET_TEST_DATA";
export const GET_TEST_DATA_SUCESS = "GET_TEST_DATA_SUCESS";
export const API_ERROR = "API_ERROR";
